export default "__VITE_ASSET__SoJDIrUJ__"